import actions from './actions';
import mutations from './mutations';

const state = {
  setting_list: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
